/**
 * @file entry
 * @author gaofeng(gaofeng@dongqiudi.com)
 */

import Vue from 'vue';
import VueMeta from 'vue-meta';
import { createRouter } from './router';
import { createStore } from './store';
import App from './App.vue';
import './util/performance';
import '../public/js/format';
import Toast from 'vue2-toast';
import './app.css';
import 'vue2-toast/lib/toast.css';
import VueI18n from 'vue-i18n';
import messages from '@/lang/index.js';

Vue.use(Toast, {
    defaultType: 'center',
    duration: 3000,
    wordWrap: true
});

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages
});

Vue.use(VueMeta, {
    keyName: 'head', // vuemeta的参数名称
    attribute: 'data-vue-meta', // 由vue-meta渲染的元素会添加一个属性 <title data-vue-meta=""></title>
    ssrAttribute: 'data-vue-meta-server-rendered', // 由服务器端渲染的vue-meta元素的自定义属性名称
    tagIDKeyName: 'vmid' // vue-meta用于确定是否覆盖或附加标签的属性名称
});
Vue.config.productionTip = false;

const isWebpSupport = (function () {
    var support = null;
    return function (that) {
        if (support !== null) {
            return support;
        }
        if (process.env.VUE_ENV !== 'server') {
            var elem = document.createElement('canvas');

            if (elem.getContext && elem.getContext('2d')) {
                support = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
            } else {
                support = false;
            }
        } else if (that && that.$ssrContext && that.$ssrContext.userAgent) {
            let userAgent = that.$ssrContext.userAgent;
            if (userAgent.indexOf('opera') > -1 || userAgent.indexOf('chrome') > -1) {
                support = true;
            } else {
                support = false;
            }
        }
        return support;
    };
})();

Vue.mixin({
    created () {
        if (this.$route && this.$route.query) {
            let locale = this.$route.query.language || '';
            locale = locale.split('-')[0];
            i18n.locale = locale || 'en';
        }
    },
    methods: {
        getUrlTitle (title) {
            return title && encodeURIComponent(
                title.split(/[:%#;,&[\]!?"'/\\]/).join('').split(' ').join('-')
            );
        },
        getImgSrc (src) {
            if (!src) {
                return '';
            }
            if (src.indexOf('img.allfootballapp.com') > -1 && /.(jpe?g|png)/.test(src)) {
                if (isWebpSupport(this)) {
                    src = src + '.webp';
                }
            }
            // NGINX转过来的是http 这段逻辑先注释掉
            // if (process.env.VUE_ENV !== 'server' && location.protocol !== 'https:') {
            //     return src;
            // } else if (this.$ssrContext && this.$ssrContext.protocol === 'http') {
            //     return src;
            // }
            return src
                .replace(/https?:\/\//, '//')
                .replace('//img.allfootballapp.com', '//img.allfootballapp.com')
                .replace('//s3.allfootballapp.com', '//s3.allfootballapp.com');
        }
    }
});

Vue.directive('teamLogo', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
        // 聚焦元素
        const defaultSrc = location.protocol === 'https:'
            ? 'https://img-sd.allfootballapp.com/fastdfs3/M00/B9/F9/ChOxM1xIEDOAbu7VAAAWn39BUY0523.png'
            : 'http://img-sd.allfootballapp.com/fastdfs3/M00/B9/F9/ChOxM1xIEDOAbu7VAAAWn39BUY0523.png';

        if (!el.src) {
            el.src = defaultSrc;
        }

        el.onerror = function () {
            el.src = defaultSrc;
        };
    }
});

/* eslint-disable no-new */
export function createApp () {
    let router = createRouter();
    let store = createStore();
    let app = new Vue({
        router,
        store,
        i18n,
        ...App
    });
    return { app, router, store };
}



// WEBPACK FOOTER //
// ./src/app.js